/**
 * Handing a downloaded file to the browser.
 *
 * Split from `ExportMenu.tsx` so that file exports only a component, which is
 * what React Fast Refresh needs to reload a component without reloading the
 * page.
 */

/**
 * Hand a downloaded blob to the browser.
 *
 * The object URL is revoked on a timer rather than immediately: Safari starts
 * the download asynchronously and a URL revoked in the same tick produces a
 * zero-byte file.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** `customers-2026-09-20.csv` - a name that sorts and says when it was taken. */
export function stampedFilename(base: string, extension = 'csv'): string {
  return `${base}-${new Date().toISOString().slice(0, 10)}.${extension}`;
}
